import React, { useState } from 'react';
import { Coffee, Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Ecosystem',
    href: '#ecosystem'
  }, {
    name: 'Products',
    href: '#products'
  }, {
    name: 'Philosophy',
    href: '#philosophy'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100" data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="flex justify-between items-center h-20" data-id="element-164">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" data-id="element-165">
            <div className="bg-teal-600 p-2 rounded-lg text-white" data-id="element-166">
              <Coffee size={24} data-id="element-167" />
            </div>
            <span className="font-bold text-xl tracking-tight text-gray-900" data-id="element-168">
              LATTEWARE
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-169">
            <div className="flex gap-6" data-id="element-170">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-600 hover:text-teal-600 transition-colors" data-id="element-171">
                  {link.name}
                </a>)}
            </div>
            <button className="bg-teal-600 hover:bg-teal-700 text-white px-5 py-2.5 rounded-md font-medium text-sm transition-colors" data-id="element-172">
              Start a Conversation
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-173">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-gray-900 focus:outline-none" data-id="element-174">
              {isOpen ? <X size={24} data-id="element-175" /> : <Menu size={24} data-id="element-176" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 px-4 pt-2 pb-6 space-y-4 shadow-lg" data-id="element-177">
          {navLinks.map(link => <a key={link.name} href={link.href} className="block text-base font-medium text-gray-600 hover:text-teal-600 py-2" onClick={() => setIsOpen(false)} data-id="element-178">
              {link.name}
            </a>)}
          <button className="w-full bg-teal-600 hover:bg-teal-700 text-white px-5 py-3 rounded-md font-medium text-sm transition-colors mt-4" data-id="element-179">
            Start a Conversation
          </button>
        </div>}
    </nav>;
}